import { config } from "../../Config";

const ApproveExtension = async (userId, extensionId) => {
  if (!userId || !extensionId) {
    return { success: false, error: "Missing userId or extensionId" };
  }
  try {
    const res = await fetch(config.approveExtension, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId, extensionId }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      return { success: false, error: data.error || `HTTP ${res.status}` };
    }
    return { success: true, status: data.status, message: data.message };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export default ApproveExtension;
